module.exports = __webpack_public_path__ + "media/ending_soon.4882620c.ogg";